/**
 * useGestorInternal — a conversa aberta é com um número INTERNO da Ponte do
 * Gestor? Nesses threads o Gestor responde DE PROPÓSITO (pula os portões do
 * contato), e o cabeçalho dizia "Agente pausado — em atendimento com X"
 * enquanto o Gestor conversava — informação errada para o operador.
 *
 * Fonte: GET /contacts/{ref}/assignment (campo `gestor_internal`, resolvido
 * no backend com o cache da ponte). Uma chamada por conversa aberta; erro ou
 * workspace sem ponte = false (cabeçalho normal).
 *
 * Usado por wa-personal e wa-business (que leem o responsável pelo hook em
 * lote, sem este campo); Instagram e Messenger aproveitam o fetch individual
 * que já fazem.
 */
import { useEffect, useState } from 'react';
import assignmentService from '../services/global/assignmentService';

const useGestorInternal = (contactRef) => {
  const [gestorInternal, setGestorInternal] = useState(false);

  useEffect(() => {
    if (!contactRef) { setGestorInternal(false); return undefined; }
    let cancelled = false;
    setGestorInternal(false);
    assignmentService.get(contactRef)
      .then((raw) => {
        if (cancelled) return;
        const d = raw?.data ?? raw;
        setGestorInternal(!!d?.gestor_internal);
      })
      .catch(() => { if (!cancelled) setGestorInternal(false); });
    return () => { cancelled = true; };
  }, [contactRef]);

  return gestorInternal;
};

export default useGestorInternal;
